<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M4.94979 4.94974L14.8493 14.8492"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
        />
        <path
            d="M14.8492 4.94974L4.94971 14.8492"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
        />
    </svg>
</template>
<script>
export default {
    name: "CloseIcon",
};
</script>
